"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputConfirmationContent = void 0;
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
exports.TagNameInputConfirmationContent = {
    view: function (collectionCount, oldName, newName) {
        return (0, mithril_1.m)('div', [
            (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.TAG_EXISTS, newName)),
            (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.TAG_MERGE_CONFIRM, { collectionCount: collectionCount, oldName: oldName, newName: newName }))
        ]);
    }
};
//# sourceMappingURL=tag.name.input.confirmation.js.map